import { useEffect, useRef, useState } from "react";

import { useLazyLoadContacts } from "@smart/manage-gql-client-dom";
import { Gql } from "@smart/manage-gql-operations-dom";

export const useSearchContacts = ({
  name,
  shouldSearch = true,
}: {
  name: string;
  shouldSearch?: boolean;
}) => {
  // useLazyLoadContacts needs to be called here so when getContacts
  // is called, the internal state update of useLazyLoadContacts happens
  // in the same component (Typeahead).
  // Refer to https://github.com/facebook/react/issues/18178#issuecomment-602323184
  const getContacts = useLazyLoadContacts();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<Gql.ContactFieldsFragment[]>();
  const searchRef = useRef<string | undefined>(undefined);

  const canSearch = name && name.length > 1 && shouldSearch;

  useEffect(() => {
    if (!name) searchRef.current = undefined;
    if (!canSearch) return;
    if (name.length > 1 && searchRef.current !== name) {
      setResult(undefined);
      searchRef.current = name;
      setLoading(true);
      getContacts?.({
        names: [name],
      })
        .then((searchResult) => {
          setLoading(false);
          setResult(searchResult || []);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
          setResult(undefined);
        });
    }
  }, [name, getContacts, canSearch]);

  if (!canSearch) return { result: undefined, loading: false };

  return { result, loading };
};
